export const SHIPPING_FORM_NAME = 'ShippingForm';
export const SHIPPING_FORM = 'SHIPPING_FORM';
export const SHIPPING_FIELD_ADDRESS_LINE_1 = 'addressLine1';
export const SHIPPING_FIELD_ADDRESS_LINE_2 = 'addressLine2';

export const ADDRESS_FORM_MODE = {
  AUTO_SUGGEST: 'AUTO_SUGGEST',
  MANUAL: 'MANUAL',
};

export const REG_FORM_MODE = {
  FIRST_ADDRESS: 'FIRST_ADDRESS',
  VIEW_ADDRESSES: 'VIEW_ADDRESSES',
  ADD_NEW_ADDRESS: 'ADD_NEW_ADDRESS',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  SAVED_ADDRESS: 'SAVED_ADDRESS',
};

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_ADDRESS = {
  firstName: '',
  lastName: '',
  addressLine1: '',
  addressLine2: null,
  city: '',
  state: '',
  zipCode: '',
  country: DEFAULT_COUNTRY,
};

export const POBOX_DEBOUNCE_DELAY = 400;
